import GLightbox from 'glightbox';
import { tns } from 'tiny-slider/src/tiny-slider';

// Lightbox

const glightboxArrowNext = `
<svg xmlns="http://www.w3.org/2000/svg" width="32.71" height="55.417" viewBox="0 0 32.71 55.417">
  <g id="Component_5_1" data-name="Component 5 – 1" transform="translate(7.071 7.071)">
    <path id="Path_319" data-name="Path 319" d="M15294.086,1113.727l20.639,20.637L15294.086,1155" transform="translate(-15294.086 -1113.727)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="10"/>
  </g>
</svg>
`;

const glightboxArrowPrev = `
<svg xmlns="http://www.w3.org/2000/svg" width="32.71" height="55.417" viewBox="0 0 32.71 55.417">
  <g id="Component_5_1" data-name="Component 5 – 1" transform="translate(7.071 7.071)">
    <path id="Path_319" data-name="Path 319" d="M15294.086,1113.727l20.639,20.637L15294.086,1155" transform="translate(-15294.086 -1113.727)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="10"/>
  </g>
</svg>
`;

const glightboxCloseIcon = `
<svg width="100%" height="100%" viewBox="0 0 55 55" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,-15286.9,-1106.87)">
        <g id="Component_5_1">
            <path d="M15314.4,1141.74L15297.6,1158.53C15295.7,1160.49 15292.5,1160.49 15290.6,1158.54C15288.6,1156.59 15288.6,1153.42 15290.6,1151.47C15290.6,1151.47 15307.6,1134.36 15307.6,1134.36L15290.6,1117.26C15288.6,1115.31 15288.6,1112.14 15290.6,1110.19C15292.5,1108.24 15295.7,1108.24 15297.6,1110.2L15314.4,1126.98L15331.2,1110.2C15333.1,1108.24 15336.3,1108.24 15338.2,1110.19C15340.2,1112.14 15340.2,1115.31 15338.2,1117.26L15321.2,1134.36L15338.2,1151.47C15340.2,1153.42 15340.2,1156.59 15338.2,1158.54C15336.3,1160.49 15333.1,1160.49 15331.2,1158.53L15314.4,1141.74Z" style="fill:white;"/>
        </g>
    </g>
</svg>
`;

const glightbox = GLightbox({
    selector: '.lightbox',
    touchNavigation: false,
    keyboardNavigation: true,
    width: '1200px',
    svg: {
        close: glightboxCloseIcon,
        next: glightboxArrowNext,
        prev: glightboxArrowPrev
    }
});

// Tiny sliders

const sliderFocusableSelector = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'summary',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable=""]',
    '[contenteditable="true"]',
    '[tabindex]'
].join(', ');

const sliderOriginalTabindexAttribute = 'data-skoe-original-tabindex';
const sliderTabindexUnsetValue = '__none__';

function storeFocusableTabindex(element) {
    if (element.hasAttribute(sliderOriginalTabindexAttribute)) {
        return;
    }

    const originalTabindex = element.getAttribute('tabindex');

    element.setAttribute(
        sliderOriginalTabindexAttribute,
        originalTabindex === null ? sliderTabindexUnsetValue : originalTabindex
    );
}

function restoreFocusableTabindex(element) {
    const originalTabindex = element.getAttribute(sliderOriginalTabindexAttribute);

    if (originalTabindex === null) {
        return;
    }

    if (originalTabindex === sliderTabindexUnsetValue) {
        element.removeAttribute('tabindex');
    } else {
        element.setAttribute('tabindex', originalTabindex);
    }

    element.removeAttribute(sliderOriginalTabindexAttribute);
}

function setSlideInteractiveState(slide, isActive) {
    if (!slide) {
        return;
    }

    const focusableElements = slide.querySelectorAll(sliderFocusableSelector);

    if (isActive) {
        slide.removeAttribute('inert');
        focusableElements.forEach(restoreFocusableTabindex);

        return;
    }

    slide.setAttribute('inert', '');

    focusableElements.forEach(function (element) {
        storeFocusableTabindex(element);
        element.setAttribute('tabindex', '-1');
    });
}

function getActiveSlideItems(info) {
    const activeSlideItems = new Set();
    const startIndex = Number.isInteger(info.index) ? info.index : 0;
    const items = Math.max(Number.isInteger(info.items) ? info.items : 1, 1);

    for (let offset = 0; offset < items; offset += 1) {
        const slide = info.slideItems[startIndex + offset];

        if (slide) {
            activeSlideItems.add(slide);
        }
    }

    if (activeSlideItems.size > 0) {
        return activeSlideItems;
    }

    Array.from(info.slideItems).forEach(function (slide) {
        if (
            slide.classList.contains('tns-slide-active') &&
            slide.getAttribute('aria-hidden') !== 'true'
        ) {
            activeSlideItems.add(slide);
        }
    });

    return activeSlideItems;
}

function enhanceSliderNavSemantics(slider) {
    if (!slider || typeof slider.getInfo !== 'function' || !slider.events) {
        return slider;
    }

    const syncNavItems = function () {
        window.requestAnimationFrame(function () {
            const info = slider.getInfo();

            if (!info.navItems || info.navItems.length === 0) {
                return;
            }

            Array.from(info.navItems).forEach(function (navItem, index) {
                const tagName = navItem.tagName.toLowerCase();
                const defaultLabel = navItem.getAttribute('data-skoe-nav-label');
                const currentLabel = navItem.getAttribute('data-skoe-nav-label-current');
                const isCurrent = index === info.navCurrentIndex;

                if (tagName !== 'button' && tagName !== 'a') {
                    navItem.setAttribute('role', 'button');
                }

                if (defaultLabel || currentLabel) {
                    navItem.setAttribute(
                        'aria-label',
                        isCurrent && currentLabel ? currentLabel : defaultLabel || currentLabel
                    );
                }

                if (isCurrent) {
                    navItem.setAttribute('aria-current', 'true');
                } else {
                    navItem.removeAttribute('aria-current');
                }
            });
        });
    };

    syncNavItems();
    slider.events.on('indexChanged', syncNavItems);

    return slider;
}

function enhanceSliderAccessibility(slider) {
    if (!slider || typeof slider.getInfo !== 'function' || !slider.events) {
        return slider;
    }

    // Tiny Slider updates active slide state asynchronously during init and transitions.
    const syncInteractiveSlides = function () {
        window.requestAnimationFrame(function () {
            const info = slider.getInfo();
            const activeSlideItems = getActiveSlideItems(info);

            Array.from(info.slideItems).forEach(function (slide) {
                setSlideInteractiveState(slide, activeSlideItems.has(slide));
            });
        });
    };

    syncInteractiveSlides();
    slider.events.on('indexChanged', syncInteractiveSlides);
    slider.events.on('transitionEnd', syncInteractiveSlides);

    return slider;
}

function initMediaSlider(containerSelector, navContainerSelector = null) {
    const options = {
        mode: 'gallery',
        items: 1,
        container: containerSelector,
        controls: true,
        controlsText: ['', '']
    };

    if (navContainerSelector) {
        options.navPosition = 'bottom';
        options.navAsThumbnails = true;
        options.navContainer = navContainerSelector;
    } else {
        options.nav = false;
    }

    const slider = tns(options);

    enhanceSliderNavSemantics(slider);
    enhanceSliderAccessibility(slider);

    return slider;
}

if (document.querySelector('#skoe-pictures-large')) {
    initMediaSlider('#skoe-pictures-large', '#skoe-pictures-thumbnails');
}

if (document.querySelector('#home-media-slider-large')) {
    initMediaSlider('#home-media-slider-large');
}

// Simple Waypoint script
// Function to check if an element is in the viewport
function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    var threshold = window.innerHeight * 3 / 4;
    return rect.top <= threshold && rect.bottom >= 0;
}

// Animate home stats

if (document.getElementById("home-stats")) {
    document.addEventListener("DOMContentLoaded", function () {

        // Function to format numbers with decimal separator
        function formatNumberWithDecimal(number) {
            return number.toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        }

        // Function to animate the numbers with ease-in-out
        function animateNumbers() {
            var statsContainer = document.getElementById("home-stats");
            var statsElements = statsContainer.querySelectorAll(".home-stat-number");

            statsContainer.classList.add("animated");

            statsElements.forEach(function (element) {
                var originalNumber = element.innerText;
                var targetNumber = parseFloat(originalNumber.replace(',', '.')); // Convert comma to period
                var currentNumber = 0;
                var step = (targetNumber / 500); // Adjust as needed

                // Check if the original number had a floating point
                var hasFloatingPoint = originalNumber.indexOf('.') !== -1;

                var interval = setInterval(function () {
                    if (currentNumber >= targetNumber) {
                        clearInterval(interval);
                    } else {
                        currentNumber += step;

                        // Format the number with or without decimal based on the original number
                        if (hasFloatingPoint) {
                            element.innerText = formatNumberWithDecimal(currentNumber);
                        } else {
                            element.innerText = Math.round(currentNumber);
                        }
                    }
                }, 10); // Adjust the interval time as needed
            });
        }

        // Check if #home-stats is in the viewport, then trigger the animation
        var onStatsScroll = function () {
            var statsContainer = document.getElementById("home-stats");
            if (isInViewport(statsContainer)) {
                animateNumbers();
                // Remove the scroll event listener after triggering the animation
                window.removeEventListener("scroll", onStatsScroll);
            }
        };
        window.addEventListener("scroll", onStatsScroll);
    });
}

// Fade in effect

var fadeInElements = document.querySelectorAll(".fadeIn");

fadeInElements.forEach(function (fadeInElement) {
    window.addEventListener("scroll", function () {
        if (isInViewport(fadeInElement)) {
            fadeInElement.classList.add('startFadeIn');
        }
    });
});
